import React, { FC } from "react";
import { cn } from "@src/lib/utils/cn";

type Props = {
  gradientStyle: string;
  selected: boolean;
  onClick: () => void;
};

const BackgroundGradientIcon: FC<Props> = ({
  gradientStyle,
  selected,
  onClick,
}) => {
  return (
    <div
      onClick={onClick}
      className={cn(
        "w-6 h-6 rounded-[48px] m-[5px] cursor-pointer",
        selected &&
          "border-[3px] border-white h-[30px] w-[30px] m-0.5 shadow-[0px_4px_8px_rgba(0,0,0,0.04),0px_2px_4px_rgba(0,0,0,0.04),0px_1px_2px_rgba(0,0,0,0.04)]",
      )}
      style={{ background: gradientStyle }}
    ></div>
  );
};

export default BackgroundGradientIcon;
